import { defineStore, storeToRefs } from 'pinia';

import { HITL } from '@/api';
import { RuleGroup } from '@/types';
import { THROW_API_ERROR, UIEventBus } from '@/common/ui-event-bus';

export const useRuleGroupsStore = defineStore('HITL-Rule-Groups', {
  state: () => {
    return {
      isInitializing: false,
      ruleGroups: [] as RuleGroup[],
    };
  },
});

export const useRuleGroupActions = () => {
  const store = useRuleGroupsStore();

  /** Can be called multiple times - will only request once */
  const initializeRuleGroups = async () => {
    if (store.isInitializing || store.ruleGroups.length) {
      return;
    }

    try {
      store.isInitializing = true;
      const response = await HITL.ruleGroups
        .searchRuleGroups() as { data: RuleGroup[]; };

      store.ruleGroups = response.data;
      store.isInitializing = false;
    } catch (error) {
      store.isInitializing = false;
      UIEventBus.$emit(THROW_API_ERROR, { error });
    }
  };

  return { initializeRuleGroups };
};

export const useRuleGroups = () => {
  return {
    ...storeToRefs(useRuleGroupsStore()),
    ...useRuleGroupActions(),
  };
};
